<template>
  <div class="pt-10 pb-5 component-div">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          class="ml-2 question-tital-name"
          :class="isFieldDisabled ? 'disable-question' : ''"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-if="componentData.isSkippable" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }">Optional</span>
        <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span
          v-if="errors.has(`imagechoicebox-${componentData.id}`)"
          class="text-danger pl-15 fw-bold"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
          >This field is required.</span
        >
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <div class="col-auto pl-0 pr-0" v-for="(languageImageOptions, loopIndex) in componentData.languageImageOptions" :key="loopIndex">
        <b-row class="pl-40 pt-10">
          <b-form-group v-if="componentData.subType === 'Single'">
            <b-form-radio-group name="activityFormimagechoicePreview" stacked disabled>
              <b-form-radio v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" :value="option.id">
                <img class="imageBox pl-0 text-center img-size" :src="option.previewImageUrl" />
              </b-form-radio>
              <b-form-radio v-if="componentData.otherOptionId" :value="componentData.otherOptionId">
                {{ componentData.otherOptionContentField }}
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group v-if="componentData.subType === 'Multi'">
            <b-form-checkbox-group name="activityFormBooleanPreview" stacked disabled>
              <b-form-checkbox v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" :value="option.id">
                <img class="imageBox pl-0 text-center img-size" :src="option.previewImageUrl" />
              </b-form-checkbox>
              <b-form-checkbox v-if="componentData.otherOptionId" :value="componentData.otherOptionId">
                {{ componentData.otherOptionContentField }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-col cols="8"></b-col>
        </b-row>
      </div>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <div class="col-auto pl-50 pr-0" :class="isFieldDisabled ? 'disable-question' : ''" v-for="(languageImageOptions, loopIndex) in componentData.languageImageOptions" :key="loopIndex">
        <b-row>
          <b-form-group class="mb-5" v-if="componentData.subType === 'Single'">
            <b-form-radio-group v-model="componentData.optionsIds[0]" stacked :disabled="isFieldDisabled" :name="`imagechoicebox-${componentData.id}`" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" v-on:change="onChangeOptions($event)">
              <b-form-radio v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" :value="option.id">
                <img v-if="option.id != componentData.otherOptionId" class="imageBox pl-0 text-center img-size" :src="option.previewImageUrl" />
                <span v-else>{{ option.previewImageUrl }}</span>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group v-if="componentData.subType === 'Multi'">
            <b-form-checkbox-group v-model="componentData.optionsIds" stacked :disabled="isFieldDisabled" :name="`imagechoicebox-${componentData.id}`" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" v-on:change="onChangeMultiOptions($event)">
              <b-form-checkbox v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" :value="option.id">
                <img v-if="option.id != componentData.otherOptionId" class="imageBox pl-0 text-center img-size" :src="option.previewImageUrl" />
                <span v-else>{{ option.previewImageUrl }}</span>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-col cols="8"></b-col>
        </b-row>
        <b-row>
          <span class="text-danger pl-5 fw-bold pt-10" v-if="hasFieldError">{{ fieldErrorText }}</span>
          <div>
            <span class="activity-form__clear pl-0" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label class="fs-12" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ componentData.actualScore || showScore(componentData.skipScore) }}
              </div>
            </div>
          </div>
        </b-row>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <b-row v-if="componentData.optionsIds">
            <img v-for="(optionId, optionIndex) in componentData.optionsIds" :key="optionIndex" :value="optionId" :src="getImageURL(optionId, componentData.languageImageOptions)" alt width="90" />
          </b-row>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            class="answers previous-value"
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
          >
            Previous value
          </div>
          <b-row>
            <img v-for="(optionId, optionIndex) in componentData.previousOptionsIds" :key="optionIndex" :value="optionId" :src="getImageURL(optionId, componentData.languageImageOptions)" alt width="90" />
          </b-row>
          <b-row class="pt-5" v-if="componentData.previousOptionsIds">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import _ from "lodash";

export default {
  name: "activity-form-image-choice-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {}
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    isClearData: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.$validator.validateAll();
      }
    },
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && this.componentData.optionsIds.length > 0 && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  mounted() {
    try {
      this.calculateScoresMap();
    } catch (e) {}
    if (this.mode == 1) {
      this.insertOtherOption();
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  methods: {
    isScoreExcluded(optionsIds) {
      let excludeScore = false;
      if (this.componentData.languageImageOptions && this.componentData.languageImageOptions[0]) {
        if (optionsIds && optionsIds.length > 0) {
          optionsIds.forEach(answer => {
            const option = this.componentData.languageImageOptions[0].options.find(option => option.id == answer);
            if (option) {
              excludeScore = option.excludeScore;
              if (excludeScore) {
                return excludeScore;
              }
            }
          });
        }
      }
      return excludeScore;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = undefined;
      this.componentData.optionsIds = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.errors.clear();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      const parseddata = _.cloneDeep(JSON.parse(JSON.stringify(this.componentData)));
      this.$emit("onClearAnswer", parseddata);
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    getImageURL(optionId, languageImageOptions) {
      if (languageImageOptions && languageImageOptions[0] && languageImageOptions[0].options) {
        let imageURL = null;
        languageImageOptions[0].options.forEach(languageImageOption => {
          if (languageImageOption.id === optionId) {
            imageURL = languageImageOption.imageUrl;
            return;
          }
        });
        return imageURL;
      }
    },
    onChangeOptions(e) {
      if (e == this.componentData.otherOptionId && this.componentData.otherCommentSelectedField && this.mode == 1) {
        this.$toastr.success(this.componentData.otherCommentSelectedField);
      }
      this.$validator.validateAll().then(() => {});
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
      this.onAnswerChange();
    },
    onChangeMultiOptions(optionIds) {
      if (optionIds instanceof Array) {
        if (optionIds.includes(this.componentData.otherOptionId) && this.componentData.otherCommentSelectedField && this.mode == 1) {
          this.$toastr.success(this.componentData.otherCommentSelectedField);
        }
        this.componentData.computedScore = this.scoresMap[optionIds[0]];
        this.componentData.actualScore = this.scoresMap[optionIds[0]];
      } else {
        this.componentData.computedScore = this.scoresMap[optionIds];
        this.componentData.actualScore = this.scoresMap[optionIds];
      }
      this.onAnswerChange();
    },
    calculateScoresMap() {
      if (this.componentData.languageImageOptions) {
        this.componentData.languageImageOptions[0].options.forEach(option => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId) {
        const sequence = this.componentData.languageImageOptions[0].options.length + 1;
        this.componentData.languageImageOptions[0].options.push({
          enabled: true,
          excludeScore: false,
          formattedBody: "",
          id: this.componentData.otherOptionId,
          imageId: this.componentData.otherOptionId,
          imageUrl: this.componentData.otherOptionContentField,
          isAdvancedScoring: false,
          previewImageUrl: this.componentData.otherOptionContentField,
          priority: 0,
          score: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.component-div:hover .icons-div {
  display: block;
}
.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 110px;
  max-height: 110px;
  padding: 5px;
}
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
